import { createServerOnlyFn } from "@tanstack/react-start";
import {
    disableKitsEnvironmentRoute,
    registerKitsEnvironmentRoute,
    resolveSendblueEnvironmentRoutes,
} from "./route.server.ts";

export const kitsEnvironmentRoutesApiRoute = {
    server: {
        handlers: {
            DELETE: createServerOnlyFn(({ request }: { request: Request }) =>
                disableKitsEnvironmentRoute(request),
            ),
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                registerKitsEnvironmentRoute(request),
            ),
        },
    },
};

export const sendblueEnvironmentRoutesApiRoute = {
    server: {
        handlers: {
            POST: createServerOnlyFn(({ request }: { request: Request }) =>
                resolveSendblueEnvironmentRoutes(request),
            ),
        },
    },
};
